import { styled } from "../../../styles";

/**
 * One language row of a custom medication's names: language select, name
 * input, remove action. The select keeps a fixed width so the names line up.
 */
export const NameRow = styled("div", {
  display: "grid",
  gridTemplateColumns: "180px minmax(0, 1fr) 32px",
  alignItems: "start",
  gap: "8px",
});

export const NameRows = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

/** Comma-separated language codes in the list's Translations column. */
export const LanguageCodes = styled("span", {
  fontSize: "13px",
  color: "$gray-80",
});

/** The note textarea, sized like the inputs around it. */
export const NotesInput = styled("textarea", {
  width: "100%",
  minHeight: "72px",
  padding: "8px 12px",
  border: "1px solid $gray-30",
  borderRadius: "8px",
  fontFamily: "inherit",
  fontSize: "14px",
  resize: "vertical",
});

/** A label read by assistive tech but not drawn — each row's language select. */
export const VisuallyHiddenLabel = styled("label", {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
});
